import {Skeleton} from '@mui/material'
import {Tooltip} from "../../../../../../common/tooltipv2";
import {useTranslation} from "react-i18next";
import {Switch} from "../../../../../../common/switch";
import React, {useState} from "react";
import ReactImageFallback from "react-image-fallback";
import noImg from "../../../../../ControlPanel/component/topproduct/images/no-img.png";
import {CellStatusComment} from "./_cellStatusComment";
import {StyledFacebookMessageConfirmOrder_Tbody} from "./_styled";
import {ICONS} from "../../../autoResponsesMessage/interface/_constants";
export const FacebookMessageConfirmOrder_Tbody = ({
  data,
  loading,
  ...props
}) => {
    const {t} = useTranslation()
  if (loading)
    return (
      <StyledFacebookMessageConfirmOrder_Tbody {...props}>
        {Array.from(Array(3), (e, i) => (
          <div key={i} className="facebook-message-confirm-order-tbody__td">
            <Skeleton
              sx={{
                width: '100%',
                height: 33,
                background:
                  'linear-gradient(0deg, rgba(244, 247, 252, 0.98), rgba(244, 247, 252, 0.98)), #00081D;',
              }}
            />
          </div>
        ))}
      </StyledFacebookMessageConfirmOrder_Tbody>
    )

  return (
    <StyledFacebookMessageConfirmOrder_Tbody {...props}>
      <div className="facebook-message-confirm-order-tbody__td">
        <div className="--ellipsis">
            <ReactImageFallback
                src={data?.page_avatar}
                fallbackImage={noImg}
                alt="img bottom img"
                className="facebook-message-confirm-order-tbody__image"
            />
            <Tooltip className='tooltipV2_message' baseOn={'height'} placement="bottom-start" title={data?.message} >
                {data?.page_name || '---'}
            </Tooltip>
        </div>
      </div>
      <div className="facebook-message-confirm-order-tbody__td">
          <CellStatusComment id={data.status}>
              {+data.status === 1 ? t('facebookManagement_connected') : t('facebookManagement_notConnected')}
          </CellStatusComment>
      </div>
            <div className="facebook-message-confirm-order-tbody__td">
              <Switch
                  checked={+(data.product_print_config || 0) === 1}
                  onChange={() => props?.onChangeStatus(data)}
              />
            </div>
    </StyledFacebookMessageConfirmOrder_Tbody>
  )
}
